/*
 * "Is this for your horse? Save Cob as their headcollar size" - for GUESTS, inside the site's own "Added to cart" card
 * (29 Sept 2026). Aaron wants shoppers who have no account yet to get the "we know my horse" treatment too, and chose
 * to see this in real before deciding ("I don't know if I like the add-to-cart one. I'd have to see it in real").
 *
 * When a guest adds a horse item with a size (rug, headcollar / bridle / fly mask / horse boots, girth, bit), the card
 * gets one soft blue panel with one big button. "Yes" keeps the size in THEIR browser only (they asked for it - nothing
 * is sent to us); from then on assets/jhr-usual-size.js picks that size on other horse items and tags it "Your Horse"
 * in the size list. "No thanks" = not asked again about that kind of item for 30 days. While the panel is showing the
 * card's own countdown waits, so nobody has to read against the clock; after an answer it counts down as normal.
 *
 * Data: the product page's <script data-jhr-horse> (snippets/jhr-usual-size.liquid): the kind, a plain name for the
 * item, and every variant's size. Signed-in customers never see this (their sizes come from their account).
 */
(function () {
  'use strict';
  var el = document.querySelector('script[data-jhr-horse]');
  if (!el || window.jhrHorseSave) return;
  window.jhrHorseSave = true;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var KEY = 'jhr_horse';
  var DAY = 864e5;

  function read() {
    try {
      var o = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (o && o.v === 1) { o.sizes = o.sizes || {}; o.declined = o.declined || {}; return o; }
    } catch (e) { /* storage blocked: behave as empty */ }
    return { v: 1, sizes: {}, declined: {} };
  }
  function write(o) {
    try { window.localStorage.setItem(KEY, JSON.stringify(o)); return true; } catch (e) { return false; }
  }
  var norm = function (s) { return String(s || '').toLowerCase().replace(/["”″\s]/g, '').replace(/ft/g, "'"); };
  function text(tag, cls, value) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (value != null) n.textContent = value;
    return n;
  }

  // The newest Added-to-cart card, once it has drawn its body (it builds itself as it is added to the page).
  function whenCard(done) {
    var tries = 0;
    (function look() {
      var cards = document.querySelectorAll('added-notification.jhr-anv2:not(.added-notification--dismissed)');
      var card = cards[cards.length - 1];
      var body = card && card.querySelector('.jhr-an__body');
      if (body) { done(card, body); return; }
      if (++tries < 40) window.setTimeout(look, 75);          // up to 3 s
    })();
  }

  function ask(card, body, size) {
    if (card.querySelector('.jhr-hs')) return;
    var panel = text('div', 'jhr-hs');
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Save your horse\'s size');
    panel.appendChild(text('p', 'jhr-hs__q', 'Is this for your horse?'));
    var line = text('p', 'jhr-hs__t');
    line.appendChild(document.createTextNode('Save '));
    line.appendChild(text('b', null, size));
    line.appendChild(document.createTextNode(' as their ' + (data.noun || 'horse') + ' size and we\'ll choose it for you next time.'));
    panel.appendChild(line);
    var yes = text('button', 'jhr-hs__yes', 'Yes, save ' + size);
    yes.type = 'button';
    var no = text('button', 'jhr-hs__no', 'No Thanks');
    no.type = 'button';
    panel.appendChild(yes);
    panel.appendChild(no);
    body.insertAdjacentElement('afterend', panel);
    // No reading against the clock: the card's countdown waits until they answer. The card starts its countdown on its
    // own schedule (after it has slid in, and again when the mouse leaves it) by adding "jhr-an--counting", so the
    // pause goes back on every time that class appears - found on the V19.7 trial: pausing once, early, was undone.
    // 2 Oct 2026 (Aaron: the card first stayed open forever, then its countdown "about halfway through it resets
    // itself"): no pausing and restarting here. The card counts down once - for longer while this question is unanswered
    // (added-notification.js AUTO_DISMISS_QUESTION) - and closes if nobody answers. If it was already counting when the
    // question arrived, it restarts now, straight away, so the ring simply begins. A touch keeps it open (the card's own
    // phone rule); an answer restarts it at the normal length so "Saved" is seen.
    if (card.classList.contains('jhr-an--counting') && !card.classList.contains('jhr-an--paused') && typeof card._start === 'function') {
      card._start();
    }
    var resume = function () {
      if (typeof card._start === 'function') card._start();
    };

    yes.addEventListener('click', function () {
      var o = read();
      o.sizes[data.kind] = size;
      delete o.declined[data.kind];
      var ok = write(o);
      panel.classList.add('jhr-hs--done');
      panel.innerHTML = '';
      panel.appendChild(text('p', 'jhr-hs__t', ok ? '✓ Saved. Next time we\'ll choose ' + size + ' for your horse.'
        : 'Sorry - this browser would not let us save it.'));
      resume();
    });
    no.addEventListener('click', function () {
      var o = read();
      o.declined[data.kind] = Date.now();
      write(o);
      panel.remove();
      resume();
    });
  }

  document.addEventListener('on:cart:add', function (evt) {
    var id = evt && evt.detail && evt.detail.variantId;
    var v = id != null ? data.variants[String(id)] : null;
    var size = v && v[0];
    // 3 Oct 2026 (Aaron: "it seems to be asking for a one size option"): a one-size item has no size to remember
    if (!size || /\bone[\s-]?size\b|\bonesize\b|^\s*(o\/s|os|universal)\s*$/i.test(size)) return;   // not 'Universal 4/5' (SSG gloves' real sizes)
    var o = read();
    if (o.sizes[data.kind] && norm(o.sizes[data.kind]) === norm(size)) return;   // already their horse's size
    var said = o.declined[data.kind];
    if (said && Date.now() - said < 30 * DAY) return;                          // "No thanks" lately
    whenCard(function (card, body) { ask(card, body, size); });
  });
})();
